<template>
  <div>
    <BjDrawerForm
      ref="BjDrawerForm"
      class="actual-drawer-form"
      :form="form"
      width="800px"
      label-width="120px"
      :confirm-button-text="isView ? '' : $t('okText')"
      @handleConfirm="handleConfirm"
    >
      <div v-for="section in actualStaffSections" :key="section.listName" class="actual-staff-section">
        <BjDivider>
          {{ section.title }}
          <span class="actual-staff-section-subtitle">{{ section.subtitle }}</span>
          <template slot="right">
            <!-- 弃用所有实际用人数据 -->
            <el-button v-if="isView && section.listName === 'staffList'" type="danger" @click="discardActualData()">{{ $t('discardText') }}</el-button>
            <el-button v-if="!isView" type="primary" @click="onAddStaff(section)">{{ $t('addText') }}</el-button>
          </template>
        </BjDivider>
        <el-form :ref="section.formRef" :model="form" :rules="section.rules">
          <el-table :ref="section.tableRef" class="actual-allocation-table" :data="form[section.listName]" stripe border>
            <el-table-column type="expand" width="1" class-name="work-detail-expand">
              <template slot-scope="{ row }">
                <div class="work-detail-panel">
                  <div class="work-detail-grid work-detail-grid--header">
                    <div>{{ $t('AccountManagement.work.count') }}</div>
                    <div>{{ $t('AccountManagement.work.targetGroup') }}</div>
                    <div>{{ $t('AccountManagement.work.percentage') }}</div>
                    <div>{{ $t('AccountManagement.work.action') }}</div>
                  </div>
                  <div v-for="(detail, detailIndex) in row.workDetails" :key="detailIndex" class="work-detail-grid">
                    <div>{{ detailIndex + 1 }}</div>
                    <div>
                      <BjSelectLov v-model="detail.deptName" :option-list="departmentOptionList" :clearable="false" :disabled="isView" />
                    </div>
                    <div class="work-detail-percentage">
                      <BjInputNumber v-model="detail.percentage" class="work-detail-percentage-input" :min="0" :max="100" :precision="0" :disabled="isView">
                        <template slot="append">%</template>
                      </BjInputNumber>
                    </div>
                    <div>
                      <el-button :disabled="isView" type="text" class="work-detail-delete" icon="el-icon-delete" @click="onDeleteWorkDetail(row, detailIndex, section.tableRef, section.listName)" />
                    </div>
                  </div>
                  <div class="work-detail-add-row">
                    <div></div>
                    <div class="work-detail-add-cell">
                      <el-button :disabled="isView" type="text" icon="el-icon-plus" class="work-detail-add" @click="onAddWorkDetail(row)">{{ $t('AccountManagement.work.addGroup') }}</el-button>
                    </div>
                    <div></div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column type="index" :label="$t('AccountManagement.work.count')" align="center" width="80" />
            <el-table-column align="center">
              <template #header><span class="red">*</span> {{ $t('AccountManagement.staff.name') }}</template>
              <template slot-scope="{ row, $index }">
                <el-form-item :prop="`${section.listName}.${$index}.name`" style="margin-top:10px !important;">
                  <span>{{ row.name }}</span>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column align="center" width="300">
              <template #header><span class="red">*</span> {{ $t('AccountManagement.work.hour') }}</template>
              <template slot-scope="{ row, $index }">
                <el-form-item :prop="`${section.listName}.${$index}.${section.hourField}`" :rules="section.rules[section.hourField]" style="margin-top:10px !important;">
                  <div class="work-hour-range-picker">
                    <el-time-picker
                      :value="row[section.hourField] && row[section.hourField][0]" format="HH:mm" value-format="yyyy-MM-dd HH:mm:ss" class="work-hour-picker"
                      :placeholder="$t('form.startTimeText')"
                      :picker-options="getStartTimePickerOptions(row[section.hourField])"
                      prefix-icon=""
                      :disabled="isView"
                      :editable="false"
                      @input="setWorkHour(row, section.hourField, 0, $event)"
                    />
                    <span class="work-hour-separator">-</span>
                    <el-time-picker
                      :value="row[section.hourField] && row[section.hourField][1]" format="HH:mm" value-format="yyyy-MM-dd HH:mm:ss" class="work-hour-picker"
                      :placeholder="$t('form.endTimeText')"
                      :picker-options="getEndTimePickerOptions(row[section.hourField])"
                      prefix-icon=""
                      :disabled="isView"
                      :editable="false"
                      @input="setWorkHour(row, section.hourField, 1, $event)"
                    />
                  </div>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column :label="$t('BusinessThirdOrderAdd.form.Operation')" align="center" fixed="right" width="150">
              <template slot-scope="scope">
                <el-button type="text" @click="onToggleAllocate(scope.row, section.tableRef, section.listName)">{{ isRowExpanded(scope.row, section.listName) ? $t('AccountManagement.work.close') : $t('AccountManagement.work.allocate') }}</el-button>
                <el-button :disabled="isView" type="text" @click="onDelete(scope.$index, section)">{{ $t('delText') }}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
      </div>

    </BjDrawerForm>
    <BjLogTableDialog ref="logTable" :query-api="queryApi" :query-params="queryParams" :staff-role-list="staffRoleList" :staff-dept-list="staffDeptList" @onConfirm="onConfirm">
      <template v-slot:baseForm>
        <el-col :span="6">
          <el-form-item :label="$t('AccountManagement.staff.name')" prop="staffName">
            <BjInput v-model="queryParams.staffName" :placeholder="$t('AccountManagement.staff.name')" @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('AccountManagement.staff.department')" prop="staffDepartment">
            <BjSelectLov v-model="queryParams.staffDepartment" :option-list="staffDeptList" :placeholder="$t('AccountManagement.staff.department')" @change="handleQuery" />
          </el-form-item>
        </el-col>
      </template>
    </BjLogTableDialog>
  </div>
</template>

<script>
import { funConfigApi } from '@/api';
import {
  addWorkDetail,
  deleteWorkDetail,
  ensureWorkDetails,
  mergeActualStaffList,
  normalizeWorkDetails,
  toggleExpandedRow,
  validateWorkDetailsList
} from './actualAllocation';

const DEFAULT_WORK_HOUR_START = '09:00:00';
const DEFAULT_WORK_HOUR_END = '17:30:00';
const WORK_HOUR_MAX_MINUTES = 8.5 * 60;
const DAY_START_MINUTES = 0;
const DAY_END_MINUTES = 23 * 60 + 59;

export default {
  props: {
    // 工种下拉框数据
    staffRoleList: {
      type: [Array, Object],
      default() {
        return [];
      },
    },
    // 工种下拉框数据
    staffDeptList: {
      type: [Array, Object],
      default() {
        return [];
      },
    },
  },
  data() {
    const validateWorkHours = (rule, value, callback) => {
      if (!this.isValidWorkHourRange(value)) {
        callback(new Error(this.$t('chooseText')));
      } else {
        callback();
      }
    };
    return {
      // 传入参数
      department: null,
      workDate: null,
      isView: false,
      // 表单数据
      form: {
        department: null,
        workDate: null,
        staffList: [],
        casualList: [],
        labourList: [],
      },
      queryApi: funConfigApi.getWarehouseStaffList,
      queryParams: {
        staffName: null,
        staffDepartment: null,
        staffType: null,
      },
      currentStaffSection: null,
      expandedRows: {
        staffList: [],
        casualList: [],
        labourList: [],
      },
      // 内部人员必填验证
      staffListRules: {
        staffListHours: [{ required: true, validator: validateWorkHours, trigger: 'change' }],
      },
      casualListRules: {
        casualListHours: [{ required: true, validator: validateWorkHours, trigger: 'change' }],
      },
      labourListRules: {
        labourListHours: [{ required: true, validator: validateWorkHours, trigger: 'change' }],
      },
    };
  },
  computed: {
    departmentOptionList() {
      return this.staffDeptList.length ? this.staffDeptList : [{ label: this.department, value: this.department }];
    },
    actualStaffSections() {
      return [
        {
          title: this.$t('AccountManagement.work.fullTime'),
          subtitle: this.$t('AccountManagement.work.fullTimeOnly'),
          listName: 'staffList',
          hourField: 'staffListHours',
          staffType: '1',
          formRef: 'staffList',
          tableRef: 'staffTable',
          rules: this.staffListRules,
        },
        {
          title: this.$t('AccountManagement.work.casual'),
          subtitle: this.$t('AccountManagement.work.casualOnly'),
          listName: 'casualList',
          hourField: 'casualListHours',
          staffType: '2',
          formRef: 'casualList',
          tableRef: 'casualTable',
          rules: this.casualListRules,
        },
        {
          title: this.$t('AccountManagement.work.labourHireSection'),
          subtitle: this.$t('AccountManagement.work.labourHireOnly'),
          listName: 'labourList',
          hourField: 'labourListHours',
          staffType: '3',
          formRef: 'labourList',
          tableRef: 'labourTable',
          rules: this.labourListRules,
        },
      ];
    },
  },
  methods: {
    getTimePart(value) {
      const match = String(value || '').match(/(\d{2}:\d{2}:\d{2})$/);
      return match ? match[1] : '';
    },
    getTimeMinutes(value) {
      const time = this.getTimePart(value);
      if (!time) return null;
      const [hour, minute] = time.split(':').map(Number);
      if (Number.isNaN(hour) || Number.isNaN(minute)) return null;
      return hour * 60 + minute;
    },
    formatTimeMinutes(value) {
      const minutes = Math.max(DAY_START_MINUTES, Math.min(DAY_END_MINUTES, value));
      const hour = Math.floor(minutes / 60);
      const minute = minutes % 60;
      return `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}:00`;
    },
    getTimeRange(minMinutes, maxMinutes) {
      return `${this.formatTimeMinutes(minMinutes)} - ${this.formatTimeMinutes(maxMinutes)}`;
    },
    getStartTimePickerOptions(hours) {
      const endMinutes = this.getTimeMinutes(hours && hours[1]);
      const minMinutes = DAY_START_MINUTES;
      const maxMinutes = endMinutes === null ? DAY_END_MINUTES : endMinutes;
      return {
        selectableRange: this.getTimeRange(minMinutes, maxMinutes),
      };
    },
    getEndTimePickerOptions(hours) {
      const startMinutes = this.getTimeMinutes(hours && hours[0]);
      const minMinutes = startMinutes === null ? DAY_START_MINUTES : startMinutes;
      const maxMinutes = startMinutes === null ? DAY_END_MINUTES : Math.min(DAY_END_MINUTES, startMinutes + WORK_HOUR_MAX_MINUTES);
      return {
        selectableRange: this.getTimeRange(minMinutes, maxMinutes),
      };
    },
    setWorkHour(row, field, index, value) {
      const hours = Array.isArray(row[field]) ? row[field].slice() : [];
      hours[index] = value;

      const startTime = this.getTimePart(hours[0]);
      const endTime = this.getTimePart(hours[1]);
      if (startTime && this.getTimeMinutes(startTime) === null) {
        hours[0] = null;
      }
      if (endTime && this.getTimeMinutes(endTime) === null) {
        hours[1] = null;
      }
      if (hours[0] && hours[1] && !this.isValidWorkHourRange(hours)) {
        hours[index === 0 ? 1 : 0] = null;
      }

      this.$set(row, field, hours);
    },
    isValidWorkHourRange(value) {
      const startMinutes = Array.isArray(value) ? this.getTimeMinutes(value[0]) : null;
      const endMinutes = Array.isArray(value) ? this.getTimeMinutes(value[1]) : null;
      if (startMinutes === null || endMinutes === null) return false;
      return startMinutes <= endMinutes && endMinutes - startMinutes <= WORK_HOUR_MAX_MINUTES;
    },
    // 弃用所有计划用人数据
    discardActualData() {
      this.$confirm(this.$t('toast.operationText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      }).then(() => {
        funConfigApi.discardWorkforceActual({department: this.department, workDate: this.workDate}).then(res => {
          if (res.failed == false) {
            this.msgSuccess(this.$t('toast.operationSuccessText'));
            this.$refs.BjDrawerForm.hide();
            this.reFresh();
          }
        });
      });
    },
    // 数据回显
    getDefaultHours() {
      const datePrefix = this.workDate ? this.workDate.substring(0, 10) : new Date().toISOString().substring(0, 10);
      return [`${datePrefix} ${DEFAULT_WORK_HOUR_START}`, `${datePrefix} ${DEFAULT_WORK_HOUR_END}`];
    },
    parseListHours(value, defaultHours) {
      if (Array.isArray(value)) return value;
      if (!value) return defaultHours;
      try {
        const parsedValue = JSON.parse(value);
        return Array.isArray(parsedValue) ? parsedValue : defaultHours;
      } catch (e) {
        return defaultHours;
      }
    },
    normalizeActualStaffList(list, hourField, defaultHours) {
      return Array.isArray(list) ? list.map(item => ({
        ...item,
        name: item.name || item.staffName,
        [hourField]: this.parseListHours(item[hourField], defaultHours),
        workDetails: normalizeWorkDetails(item.workDetails, this.department)
      })) : [];
    },
    getActualData() {
      const defaultHours = this.getDefaultHours();
      funConfigApi.getWorkforceStaffActual({department: this.department, workDate: this.workDate}).then(res => {
        const actualData = res || {};
        this.form = {
          staffList: this.normalizeActualStaffList(actualData.staffList, 'staffListHours', defaultHours),
          casualList: this.normalizeActualStaffList(actualData.casualList, 'casualListHours', defaultHours),
          labourList: this.normalizeActualStaffList(actualData.labourList, 'labourListHours', defaultHours),
        };
      });
    },
    show() {
      this.getActualData();
      this.$refs.BjDrawerForm.setTitle(this.$t('AccountManagement.work.fillActual'));
      this.$refs.BjDrawerForm.show();
    },
    // 新增内部人员
    onAddStaff(section) {
      this.currentStaffSection = section;
      this.queryParams = {
        staffName: null,
        staffDepartment: null,
        staffType: section.staffType,
      };
      this.$refs.logTable.selectedRows = [];
      this.$refs.logTable.show();
    },
    // 新增内部人员
    onConfirm(event) {
      const section = this.currentStaffSection || this.actualStaffSections[0];
      const defaultHours = this.getDefaultHours();
      this.form[section.listName] = mergeActualStaffList(this.form[section.listName], event, defaultHours, this.department, section.hourField);
      setTimeout(() => {
        // 清空内部人员表单验证
        this.clearListValidate(section.formRef);
      }, 100);
    },
    // 处理时间数据格式化
    formatTimeData(timeStr, workDatePrefix) {
      const spaceIndex = timeStr.indexOf(' ');
      return workDatePrefix + timeStr.substring(spaceIndex);
    },
    ensureWorkDetails(row) {
      return ensureWorkDetails(row, this.department, this.$set);
    },
    resolveRef(refName) {
      const ref = this.$refs[refName];
      return Array.isArray(ref) ? ref[0] : ref;
    },
    clearListValidate(refName, prop) {
      const formRef = this.resolveRef(refName);
      if (!formRef) return;
      if (prop) {
        formRef.clearValidate(prop);
        return;
      }
      formRef.clearValidate();
    },
    validateListForm(refName) {
      const formRef = this.resolveRef(refName);
      if (!formRef) return Promise.resolve(true);
      return new Promise(resolve => {
        formRef.validate(valid => {
          resolve(valid);
        });
      });
    },
    getExpandedRows(listName) {
      return this.expandedRows[listName] || [];
    },
    setExpandedRows(listName, rows) {
      this.$set(this.expandedRows, listName, rows);
    },
    isRowExpanded(row, listName) {
      return this.getExpandedRows(listName).includes(row);
    },
    onToggleAllocate(row, tableRef, listName) {
      const result = toggleExpandedRow(this.getExpandedRows(listName), row);
      if (result.expanded) {
        this.ensureWorkDetails(row);
      }
      this.setExpandedRows(listName, result.expandedRows);
      const table = this.resolveRef(tableRef);
      if (table) {
        table.toggleRowExpansion(row, result.expanded);
      }
    },
    onAddWorkDetail(row) {
      addWorkDetail(row, this.department, this.$set);
    },
    onDeleteWorkDetail(row, index, tableRef, listName) {
      const result = deleteWorkDetail(row, index, this.department, this.$set);
      if (result.shouldCollapse && this.isRowExpanded(row, listName)) {
        this.onToggleAllocate(row, tableRef, listName);
      }
    },
    getWorkDetailsMessages() {
      return {
        duplicateDept: this.$t('AccountManagement.work.workDetailsDuplicateDept'),
        percentageNotEqual100: this.$t('AccountManagement.work.workDetailsPercentageNotEqual100'),
        dataError: this.$t('AccountManagement.work.workDetailsDataError')
      };
    },
    prepareActualListForSubmit(list, hourField, workDatePrefix) {
      return (list || []).map(item => {
        const hours = Array.isArray(item[hourField]) ? item[hourField] : [];
        const updatedHours = hours.map(timeStr =>
          this.formatTimeData(timeStr, workDatePrefix)
        );
        return {
          name: item.name || item.staffName,
          startTime: updatedHours[0],
          endTime: updatedHours[1],
          [hourField]: JSON.stringify(updatedHours),
          workDetails: normalizeWorkDetails(item.workDetails, this.department).map(detail => ({
            deptName: detail.deptName || this.department,
            percentage: String(detail.percentage)
          })),
        };
      });
    },
    // 增强人员数据：添加 startTime、endTime 字段
    enhanceStaffData(data) {
      const workDatePrefix = data.workDate.substring(0, 10);
      return {
        ...data,
        staffList: this.prepareActualListForSubmit(data.staffList, 'staffListHours', workDatePrefix),
        casualList: this.prepareActualListForSubmit(data.casualList, 'casualListHours', workDatePrefix),
        labourList: this.prepareActualListForSubmit(data.labourList, 'labourListHours', workDatePrefix),
      };
    },
    // 删除
    onDelete(index, section) {
      this.$confirm(this.$t('toast.operationText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      }).then(() => {
        const list = this.form[section.listName];
        const row = list[index];
        list.splice(index, 1);
        this.setExpandedRows(section.listName, this.getExpandedRows(section.listName).filter(item => item !== row));
        setTimeout(() => {
          this.clearListValidate(section.formRef);
        }, 100);
        this.msgSuccess(this.$t('SalesOrderEntry.form.succeeded'));
      });
    },
    async handleConfirm() {
      for (const section of this.actualStaffSections) {
        const listValid = await this.validateListForm(section.formRef);
        if (!listValid) return;
      }

      const workDetailsMessages = this.getWorkDetailsMessages();
      for (const section of this.actualStaffSections) {
        const workDetailsValid = validateWorkDetailsList(this.form[section.listName], section.title, this.$message.error.bind(this.$message), workDetailsMessages);
        if (!workDetailsValid) return;
      }

      // 准备提交数据
      const API_DATA = {
        department: this.department,
        workDate: this.workDate,
        staffList: this.form.staffList,
        casualList: this.form.casualList,
        labourList: this.form.labourList,
      };

      // 处理时间数据格式化
      const POST_DATA = this.enhanceStaffData(API_DATA);

      // 提交数据
      const res = await funConfigApi.addWorkforceStaffActual(POST_DATA);
      if (!res.failed) {
        this.msgSuccess(this.$t('toast.operationSuccessText'));
        this.$refs.BjDrawerForm.hide();
        this.reFresh();
      }
    },
    hide() {
      this.$refs.BjDrawerForm.hide();
    },
    reFresh() {
      this.$emit('reFresh');
    },
  },
};
</script>
<style lang="scss">
.work-detail-expand .cell {
  display: none;
}

.el-table__expanded-cell[class*="cell"] {
  padding: 0 !important;
}

.actual-staff-section {
  margin-top: 10px;
}

.actual-staff-section-subtitle {
  margin-left: 8px;
  color: #8b98ad;
  font-size: 12px;
  font-weight: normal;
}

.actual-allocation-table th {
  color: #25364f;
  font-weight: 600;
  background: #f7f9fc;
}

.actual-allocation-table .el-table__header th .cell {
  color: #25364f;
}

.work-detail-panel {
  background: #fff;
  padding-left: 16px;
}

.work-detail-grid {
  display: grid;
  align-items: center;
  min-height: 48px;
  padding: 0;
  border-bottom: 1px solid #ebeef5;
}

.work-detail-grid > div,
.work-detail-add-row > div,
.work-detail-add-cell {
  min-height: inherit;
  border-left: 1px solid #ebeef5;
}

.work-detail-grid > div:last-child,
.work-detail-add-row > div:last-child {
  border-right: 1px solid #ebeef5;
}

.actual-allocation-table .work-detail-grid,
.actual-allocation-table .work-detail-add-row {
  grid-template-columns: 60px minmax(0, 1fr) minmax(0, 1fr) 150px;
}

.work-detail-grid:nth-child(odd):not(.work-detail-grid--header) {
  background: #fafafa;
}

.work-detail-grid--header {
  color: #2f405a;
  font-size: 12px;
  font-weight: normal;
  letter-spacing: 0;
  min-height: 40px;
  background: #f8fafc;
}

.work-detail-grid > div,
.work-detail-add-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 14px;
}

.work-detail-percentage {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.work-detail-percentage-input {
  width: 100%;
  max-width: 170px;
}

.work-detail-percentage .el-input__inner {
  text-align: center;
}

.work-hour-range-picker {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
}

.work-hour-picker {
  flex: 1;
  min-width: 0;
}

.work-hour-picker .el-input__inner {
  padding-left: 10px;
  padding-right: 24px;
  text-align: left;
}

.work-hour-picker .el-input__prefix {
  display: none;
}

.work-hour-picker.el-input--prefix .el-input__inner {
  padding-left: 10px;
}

.work-hour-separator {
  flex: 0 0 auto;
  color: #606266;
}

.work-detail-delete {
  color: #f56c6c;
}

.work-detail-add-row {
  display: grid;
  align-items: center;
  min-height: 46px;
  padding: 0;
  background: #fff;
  border-bottom: 1px solid #ebeef5;
}

.work-detail-add-cell {
  grid-column: 2 / 4;
  justify-content: flex-start;
}

.work-detail-add {
  margin-left: 0;
}

.actual-drawer-form.drawer-data-form-20210720 {
  .el-drawer__header {
    margin-bottom: 0;
    padding: 18px 28px 14px;
    border-bottom: 1px solid #e4e9f2;
  }

  .el-drawer__body {
    padding: 0;
    background: #f7f9fc;
  }

  .el-drawer__body form.bj-label-colon {
    padding: 12px 28px 16px;
    background: #fff;
  }

  .actual-staff-section .bj-divider {
    padding: 8px 0;
    margin-bottom: 10px;
  }

  .actual-staff-section .bj-divider .default-text {
    font-size: 17px;
    padding-left: 12px;
  }

  .footer {
    border-top: 1px solid #dfe6f1;
    padding-top: 16px;
  }

  .footer.has-title {
    margin-bottom: 45px;
  }
}
</style>
